import { SVGProps } from 'react';

const SvgExitSign = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 15" {...props}>
        <path d="M12.444.111H1.556A1.55 1.55 0 0 0 0 1.667v3.111h1.556V1.667h10.888v10.889H1.556V9.445H0v3.11a1.556 1.556 0 0 0 1.556 1.556h10.888A1.556 1.556 0 0 0 14 12.556V1.666c0-.862-.7-1.555-1.556-1.555ZM5.507 9.896 6.61 11 10.5 7.111 6.611 3.222 5.507 4.32 7.52 6.334H0v1.555h7.521L5.507 9.896Z" />
    </svg>
);
export default SvgExitSign;
